import map from 'lodash/map';
import noop from 'lodash/noop';
import * as ko from 'knockout';
import { Router } from './router';
import { traversePath, log } from './utils';
ko.components.register('router', {
    synchronous: true,
    viewModel: { createViewModel: createViewModel },
    template: "<div data-bind=\"if: component\">\n      <div class=\"router-view\" data-bind=\"__router__\"></div>\n    </div>"
});
ko.bindingHandlers.__router__ = {
    init: function (el, valueAccessor, allBindings, viewModel, bindingCtx) {
        var $router = bindingCtx.$rawData;
        ko.applyBindingsToNode(el, {
            css: $router.component,
            component: {
                name: $router.component,
                params: $router.ctx
            }
        }, bindingCtx.extend({ $router: $router }));
        if ($router.isRoot) {
            $router.init();
        }
        else {
            $router.ctx.$parent.router.initialized
                .then(function () { return $router.init(); })
                .catch(noop);
        }
        return { controlsDescendantBindings: true };
    }
};
function createViewModel(params) {
    var router = Router.head;
    if (!router) {
        router = new Router(Router.getPathFromLocation(), undefined, params);
    }
    else {
        while (router.bound) {
            router = router.ctx.$child.router;
        }
    }
    router.bound = true;
    if (router.isRoot) {
        router.ctx.runBeforeRender()
            .then(function () {
            if (router.ctx._redirect) {
                router.ctx.runAfterRender()
                    .then(function () {
                    var _a = traversePath(router, router.ctx._redirect), r = _a.router, p = _a.path;
                    r.update(p, router.ctx._redirectArgs).catch(function (err) { return log.error('Error redirecting', err); });
                })
                    .catch(function (err) { return log.error('Error in afterRender middleware', err); });
            }
            else {
                router.ctx.render();
                map(Router.onInit, function (resolve) { return resolve(router); });
            }
        })
            .catch(function (err) { return log.error('Error in beforeRender middleware', err); });
    }
    else if (router.ctx._redirect) {
        var _a = traversePath(router, router.ctx._redirect), r_1 = _a.router, p_1 = _a.path;
        setTimeout(function () { return r_1.update(p_1, router.ctx._redirectArgs); });
    }
    return router;
}
//# sourceMappingURL=component.js.map